import React, { useRef, useState } from "react";
import axios from "axios";
import "./Translate.css";
import PopupWindow from "./PopupWindow";
import GoogleSheetPop from "./GoogleSheetPrompt";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
// const apiEndpoint = "http://localhost:8000"

const Translate = () => {
  const BASEURL = {
    TRANSLATE_SHEET: `${apiEndpoint}/api/translate-sheet`,
    GET_PROMPT: `${apiEndpoint}/api/get-googlesheet-prompt`,
    CHECK_JOB_STATUS: `${apiEndpoint}/api/check-job-status`,
  };
  // const BASEURL = {
  //   GET_PAGEJSON: "http://localhost:8000/api/get-pagejson",
  //   TRANSLATE_JSON: "http://localhost:8000/api/translate-json",
  //   GET_PROMPT: "http://localhost:8000/api/get-live-prompt",
  //   CHECK_JOB_STATUS: "http://localhost:8000/api/check-job-status",
  // };

  const [Language, setLanguage] = useState("Simplified Chinese");
  const [model, setModel] = useState("gpt-4o-mini");
  const [mode, setMode] = useState(""); // Added mode selection status
  const [loading, setLoading] = useState(false); //Add loading effect.
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [GoogleSheetPrompt, setGoogleSheetPrompt] = useState("");
  const [GoogleSheetTemperature, setGoogleSheetTemperature] = useState(0.7);
  const [sheetInput, setSheetInput] = useState("");
  const [sheetId, setSheetId] = useState("");
  const [showToast, setShowToast] = useState(true);
  const [toastMessage, setToastMessage] = useState("Make sure you've shared your Google sheet with dev-ocean-he-v2@ai-support-401409.iam.gserviceaccount.com");
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [promptData, setPromptData] = useState({});
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [completionTime, setCompletionTime] = useState("");
  /**
 * Opens the popup by setting the state variable `isPopupOpen` to true.
 * This function is typically called when the user triggers an action that
 * requires the popup to be displayed, such as clicking a button.
 */
  const openPopup = () => {
    setIsPopupOpen(true);
    setShowToast(false);
  };
/**
 * Closes the popup by setting the state variable `isPopupOpen` to false.
 * This function is usually called when the user wants to dismiss the popup,
 * such as by clicking a close button or outside the popup area.
 */
  const closePopup = () => {
    setIsPopupOpen(false);
    setShowToast(true);
  };
/**
 * Handles the save action by updating various state variables with data from
 * the input parameter. This function is called when the user saves or submits
 * the form data from the popup.
 *
 * @param {Object} data - The data object containing the content and temperature
 *                        for different prompt types.
 * @param {Object} data.prompt - Data related to the blog prompt.
 * @param {string} data.prompt.content - The content of the blog prompt.
 * @param {number} data.prompt.temperature - The temperature setting for the blog prompt.
 */
  const handleSave = (data) => {
    setGoogleSheetPrompt(data.prompt.content);
    setGoogleSheetTemperature(data.prompt.temperature);
    if (data.language) {
    setLanguage(data.language);
  }
  };

  const handleLanguage = (event) => {
    setLanguage(event.target.value);
    console.log(Language);
  };

  const handleModel = (event) => {
    setModel(event.target.value);
    console.log(model)
  }

  // Add a new function to handle mode changes
  const handleMode = (event) => {
    setMode(event.target.value);
    console.log(mode);
  }

  const openPromptModal = () => {
    setShowPromptModal(true);
    setShowToast(false);
  };

  const closePromptModal = () => {
    setShowPromptModal(false);
    setShowToast(true);
  };

  const handleLanguageSelect = (event) => {
    setSelectedLanguage(event.target.value);
  };

/**
 * Initiates the translation process by sending a request to the translation API.
 * It first checks if there is original text to translate, then makes an asynchronous
 * request to the API. If the request is successful, it starts polling the job status
 * until the translation is complete or fails.
 *
 * @throws {Error} If there is no original text or the network response is not as expected.
 */
  const handleTranslate = async () => {
    if (!sheetId) {
      alert("Enter Sheet ID");
      return;
    }
    if (!mode) {
      alert("Please Select Mode");
      return;
    }

    setLoading(true);
    setPromptData({});
    console.log("Sending request: ", {
      PromptText: GoogleSheetPrompt,
      sheetId: sheetId,
      mode: mode,
    });
    try {
      const response = await axios.post(
        BASEURL.TRANSLATE_SHEET,
        {
          GoogleSheetPrompt: GoogleSheetPrompt,
          GoogleSheetTemperature:GoogleSheetTemperature,
          sheet_id: sheetId,
          model: model,
          mode: mode,
          return_prompts: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          validateStatus: function (status) {
            return status >= 200 && status < 500;
          }
        }
      );

      if (response.status === 202) {
        console.log(response);
        pollJobStatus(response.data.job_id);
      } else if (response.status === 403) {
        console.log(response);
        alert(`Please add permission`);
        setLoading(false);
      } else {
        console.log(response);
        throw new Error("Network response was not ok");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error translating markdown:", error);
      alert(`Error: ${error.message}`);
      setLoading(false);
    }
  };
  const pollJobStatus = (jobId) => {
    const intervalId = setInterval(async () => {
      try {
        const response = await axios.get(
          `${BASEURL.CHECK_JOB_STATUS}/${jobId}`
        );

        if (response.status !== 200) {
          throw new Error("Network response was not ok");
          setLoading(false);
        }
        const jobStatus = response.data.status;

        if (jobStatus === "completed") {
          const now = new Date();
          setCompletionTime(now.toLocaleString());
          if (response.data.result.status_code !== 200) {
            throw new Error(response.data.result.message);
          } else {
            if (response.data.result.prompts) {
              setPromptData(response.data.result.prompts);
              const languages = Object.keys(response.data.result.prompts);
              if (languages.length > 0) {
                setSelectedLanguage(languages[0]);
              }
            }
          }
          clearInterval(intervalId);
          setLoading(false);
        } else if (jobStatus === "failed") {
          clearInterval(intervalId);
          setLoading(false);
          throw new Error(response.data.message || "Translation job failed");
        }
      } catch (error) {
        clearInterval(intervalId);
        console.error("Error polling job status:", error);
        alert(`Error polling job status: ${error.message}`);
        setLoading(false);
      }
    }, 10000); // 每10秒轮询一次
  };
  const textBoxRef = useRef(null);

  // Add a function that handles input
  const handleSheetInputChange = (e) => {
    const input = e.target.value;
    setSheetInput(input);

    if (input.includes("docs.google.com/spreadsheets/d/")) {
      try {
        const regex = /\/d\/([a-zA-Z0-9-_]+)/;
        const match = input.match(regex);

        if (match && match[1]) {
          setSheetId(match[1]);
        } else {
          setSheetId(input);
        }
      } catch (error) {
        console.error("Error extracting Sheet ID from URL:", error);
        setSheetId(input);
      }
    } else {
      setSheetId(input);
    }
  };

  // 渲染提示模态框内容
  const renderPromptModalContent = () => {
    if (!selectedLanguage || !promptData[selectedLanguage]) {
      return <p>No Prompt</p>;
    }

    return (
      <div className="prompt-modal-content">
        {promptData[selectedLanguage].map((message, index) => (
          <div key={index} className="prompt-message">
            <div className="prompt-role">{message.role}:</div>
            <div className="prompt-content">{message.content}</div>
          </div>
        ))}
      </div>
    );
  };



  return (
    <div className="Translate">
      <header className="Translate-header"></header>
          <div className="Sheet-id">
            <input
              type="text"
              placeholder="Enter Google Sheet ID or URL"
              value={sheetInput}
              onChange={handleSheetInputChange}
              className="sheet-input"
            />
            {showToast && (
              <div className="toast-container">
                <div className="toast-message">
                  <span>{toastMessage}</span>
                </div>
              </div>
            )}
          </div>

      <div className="controls">
        <div className="control-group">
          <h3>Select Model</h3>
          <select value={model} onChange={handleModel}>
            <option value="gpt-4o-mini">gpt-4o-mini</option>
            <option value="gpt-4o">gpt-4o</option>
          </select>
        </div>

        <div className="control-group">
          <h3>Select Mode</h3>
          <select value={mode} onChange={handleMode}>
            <option value="">-- Please Select Mode --</option>
            <option value="product">Product</option>
            <option value="announcement">Announcement</option>
            <option value="newsletter">Newsletter</option>
          </select>
        </div>

        <div className="control-group">
          <h3>Translate</h3>
          <div className="translate-container">
            <button
              onClick={handleTranslate}
              disabled={loading}
              className={loading ? "loading-button" : ""}
            >
              {loading ? "Translating..." : "Translate"}
            </button>
            {Object.keys(promptData).length > 0 && (
              <button
                className="settings-icon"
                onClick={openPromptModal}
                title="Show Prompt"
              >
                &#9881;
              </button>
            )}
          </div>
        </div>

        <div className="control-group">
          <h3>Edit Prompt</h3>
          <button onClick={openPopup}>Edit Prompt</button>
          <GoogleSheetPop
            isOpen={isPopupOpen}
            onClose={closePopup}
            onSave={handleSave}
            initialContent={GoogleSheetPrompt}
            url={`${BASEURL.GET_PROMPT}?language=${Language}&model=${model}&mode=${mode}`}
            language={Language}
            onLanguageChange={handleLanguage}
          />
        </div>
      </div>
      {showPromptModal && (
        <div className="custom-modal-overlay" onClick={closePromptModal}>
          <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
            <div className="custom-modal-header">
              <h2>Prompt</h2>
              <button onClick={closePromptModal} className="close-button">×</button>
            </div>

            <div className="prompt-info">
              {completionTime && (
                <div className="completion-time">
                  <span>Return Time: {completionTime}</span>
                </div>
              )}

              <div className="prompt-language-selector">
                <label>Select Language: </label>
                <select value={selectedLanguage} onChange={handleLanguageSelect}>
                  {Object.keys(promptData).map(lang => (
                    <option key={lang} value={lang}>{lang}</option>
                  ))}
                </select>
              </div>
            </div>

            {renderPromptModalContent()}
          </div>
        </div>
      )}
    </div>
  );
};

export default Translate;
